import React from 'react';
import {Link, Paper, Stack, Typography} from '@mui/material';
import CoverageFintelLink from '../components/CoverageFintelLink';

/**
 * Short LLM-processed FINTEL excerpts. Each excerpt is clickable and opens the
 * FINTEL (scrolled to the excerpt when the products page supports ?q=).
 */
export default function ExcerptList({excerpts = [], onOpenReport, dense = false}) {
    if (!excerpts.length) {
        return null;
    }
    return (
        <Stack spacing={dense ? 0.75 : 1}>
            {excerpts.map((excerpt, index) => (
                <Paper
                    key={`${excerpt.reportId || 'excerpt'}-${index}`}
                    variant="outlined"
                    sx={{p: 1, bgcolor: 'grey.50', borderRadius: 1}}
                >
                    <Stack spacing={0.25}>
                        <CoverageFintelLink
                            reportId={excerpt.reportId}
                            reportTitle={excerpt.reportTitle}
                            onNavigate={(reportId) => onOpenReport?.(reportId, excerpt.text || excerpt.conclusion)}
                        />
                        {excerpt.conclusion && (
                            <Typography variant="body2" sx={{lineHeight: 1.45}}>
                                {excerpt.conclusion}
                            </Typography>
                        )}
                        {excerpt.text && (
                            <Link
                                component="button"
                                underline="none"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onOpenReport?.(excerpt.reportId, excerpt.text);
                                }}
                                sx={{textAlign: 'left', color: 'inherit'}}
                            >
                                <Typography variant="caption" color="text.secondary" sx={{fontStyle: 'italic'}}>
                                    “{excerpt.text}”
                                </Typography>
                            </Link>
                        )}
                    </Stack>
                </Paper>
            ))}
        </Stack>
    );
}
